import React, { FC } from "react"

import { DeviceDocument } from "../../../../contexts/devices-context"
import AudioModuleSettings from "./AudioModuleSettings"
import useModuleAttributes from "../../hooks/useModuleAttributes"

type DeviceAudioSettingsCardProps = {
    device: DeviceDocument
}

const _DeviceAudioModuleSettings: FC<DeviceAudioSettingsCardProps> = ({ device }) => {
    const attrs = useModuleAttributes<"duration" | "samplerate" | "gain" | "armed">(device, "audio")

    return (
        <AudioModuleSettings attrs={attrs} organisation={device.organisation} group={device.group} device={device} />
    )
}

export default _DeviceAudioModuleSettings
